import { useState, useEffect } from 'react';

type SplashPhase = 'visible' | 'fading' | 'hidden';

interface UseSplashOptions {
  dataReady: boolean;
  animationDuration?: number;
  fadeOutDuration?: number;
}

interface UseSplashResult {
  phase: SplashPhase;
  shouldRender: boolean;
}

export function useSplash({
  dataReady,
  animationDuration = 2000,
  fadeOutDuration = 600,
}: UseSplashOptions): UseSplashResult {
  const [phase, setPhase] = useState<SplashPhase>('visible');

  useEffect(() => {
    if (!dataReady || phase !== 'visible') return;

    const timer = setTimeout(() => {
      setPhase('fading');
    }, animationDuration);

    return () => clearTimeout(timer);
  }, [dataReady, phase, animationDuration]);

  useEffect(() => {
    if (phase !== 'fading') return;

    const timer = setTimeout(() => {
      setPhase('hidden');
    }, fadeOutDuration);

    return () => clearTimeout(timer);
  }, [phase, fadeOutDuration]);

  return {
    phase,
    shouldRender: phase !== 'hidden',
  };
}
